import { TableFooter as MuiTableFooter, TableRow } from "@mui/material";
import { cellStyle, CustomTableCell } from "../../styles";
import { memo, useMemo } from "react";
import { MoneyFormatv3 } from "../../../../library/MoneyFormat";
import { formatNumber } from "../../../../utils/common";

// Memoize the entire component to prevent unnecessary re-renders
export const TableFooter = memo(({ data }) => {
    // Memoize cell styles to prevent recreation on each render
   

    // Memoize calculations and formatting
    const details = useMemo(() => ({
        totalDebit: MoneyFormatv3(data?.totalDebit),
        totalCredit: MoneyFormatv3(data?.totalCredit),
        closingBalance: formatNumber(Number(data?.closingBalance) || 0, true, true, data?.balanceSign),
        balanceSign: data?.balanceSign || 0,
    }), [data?.totalDebit, data?.totalCredit, data?.closingBalance, data?.balanceSign]);

    // Memoize the TableRow to prevent unnecessary re-renders of children
    const tableContent = useMemo(() => (
        <TableRow>
            <CustomTableCell colSpan={4} sx={cellStyle}>
                <b>Total</b>
            </CustomTableCell>
            <CustomTableCell colSpan={1} sx={cellStyle}>
                <b>{details.totalDebit}</b>
            </CustomTableCell>
            <CustomTableCell colSpan={1} sx={cellStyle}>
                <b>{details.totalCredit}</b>
            </CustomTableCell>
            <CustomTableCell colSpan={1} sx={cellStyle}>
                <b>{details.closingBalance}</b>
            </CustomTableCell>
            <CustomTableCell colSpan={1} sx={cellStyle}>
                <b></b>
            </CustomTableCell>
        </TableRow>
    ), [details, cellStyle]);

    return (
        <MuiTableFooter>
            {tableContent}
        </MuiTableFooter>
    );
});

TableFooter.displayName = 'TableFooter';
